import { TmFormElement } from '@thiememeulenhoff/lit-sdk';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tagName } from '../../helpers';
import { styles } from './text-area.styles';

const tag = tagName('text-area');

@customElement(tag)
export class TextAreaComponent extends TmFormElement {
  static override styles = styles;

  @property({ type: Boolean, reflect: true })
  valid? = true;

  @property({ type: Number })
  cols?: number;

  @property({ type: Number })
  rows?: number;

  @property({ type: Number, reflect: true })
  minlength?: number;

  @property({ type: Number, reflect: true })
  maxlength?: number;

  override inputTemplate() {
    return html`
      <textarea
        part="textarea"
        id="textarea"
        name=${this.name}
        placeholder=${this.placeholder ?? nothing}
        ?disabled=${this.disabled}
        ?required=${this.required}
        ?readonly=${this.readonly}
        cols=${this.cols}
        rows=${this.rows}
        .value=${this.value !== undefined ? this.value : nothing}
        @input=${this.handleInput}
        @change=${this.handleChange}
        data-test="inner-textarea"
        minlength=${this.minlength ?? nothing}
        maxlength=${this.maxlength ?? nothing}
      ></textarea>
    `;
  }

  override handleInput(event: InputEvent) {
    if (this.minlength && this.minlength > 0) {
      this.valid =
        (event.target as HTMLInputElement).value.length >= this.minlength;
    }

    super.handleInput(event);
  }

  override render() {
    return html`
      <label part="label" for="textarea">
        <slot></slot>
      </label>
      <slot name="description"></slot>
      <div class="input-wrapper">${this.inputTemplate()}</div>
      ${this.#renderError()}
    `;
  }

  #renderError() {
    return !this.valid ? html`<slot name="error"></slot>` : nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-text-area': TextAreaComponent;
  }
}
